import { MIN_REASON_LENGTH } from "@paceroo/domain/views/admin";

/** Under a reason field: how far it is from the minimum, until it's met. */
export function ReasonHint({ reason }: { reason: string }) {
  const n = reason.trim().length;
  if (n >= MIN_REASON_LENGTH) return null;
  return (
    <span className="t-mono-xs ink-mute" aria-live="polite">
      At least {MIN_REASON_LENGTH} characters · {n} / {MIN_REASON_LENGTH}
    </span>
  );
}
